import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding/text';
import './i18n';
import { StrictMode } from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ReactQueryDevtools} from 'react-query/devtools';
import {overrideConsoleError, overrideProductionConsole} from 'web-library';
import {DefaultTheme} from 'web-library/theme';
import App from './App';
import store from './store';
import reportWebVitals from './reportWebVitals';

import {TssCacheProvider} from "tss-react";
import createCache from "@emotion/cache";
import {createRoot} from 'react-dom/client';
import {ThemeProvider} from "@mui/material";
import LibraryTssCache from "web-library/theme/LibraryTssCache";

overrideProductionConsole();
overrideConsoleError();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, retry: false, refetchOnWindowFocus: false,
    },
  },
});
const head = document.querySelector('head')
const tssInsertionPoint = document.createElement('meta')
tssInsertionPoint.setAttribute('name', 'tss-insertion-point')
tssInsertionPoint.setAttribute('content', '')
head?.appendChild(tssInsertionPoint)

const cspNonce = document.querySelector('meta[property="csp-nonce"]')

const tssCache = createCache({
  key: "tss",
  insertionPoint: tssInsertionPoint,
  stylisPlugins: [],
  nonce: cspNonce?.getAttribute("content") || ''
});

createRoot(document.getElementById('root')!).render(<>
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <LibraryTssCache>
            <TssCacheProvider value={tssCache}>
              <ThemeProvider theme={DefaultTheme}>
                <App/>
              </ThemeProvider>
            </TssCacheProvider>
          </LibraryTssCache>
          <ReactQueryDevtools initialIsOpen={false}/>
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
</>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
